import { gql } from "@apollo/client";

// export const SignUpByInviteLink = gql`
//   mutation signupByInviteLink($eventId: Int!, $inviteToken: String!) {
//     signupByInviteLink(eventId: $eventId, inviteToken: $inviteToken) {
//       access_expiry
//       access_token
//       refresh_token
//       refresh_expiry
//       user {
//         first_name
//         last_name
//         id
//         phone_number
//         verified
//         email
//       }
//     }
//   }
// `;

export const CreateMessage = gql`
  mutation createMessage($eventId: Int!, $content: String!) {
    createMessage(event_id: $eventId, content: $content)
  }
`;

export const UpdateRsvpStatus = gql`
  mutation updateRsvpStatus($eventId: Int!, $status: String!) {
    updateRsvpStatus(event_id: $eventId, status: $status)
  }
`;

// export const PayForCashGiftV1 = gql`
//   mutation payForCashGiftV1($payload: payForCashGiftRequest!) {
//     payForCashGiftV1(payload: $payload)
//   }
// `;

// export const PayForWishListItemV1 = gql`
//   mutation payForWishListItemV1($payload: payForWishlistItemRequest!) {
//     payForWishListItemV1(payload: $payload)
//   }
// `;

export const PayForSprayMoneyV1 = gql`
  mutation payForSprayMoneyV1($payload: payForSprayMoneyRequest!) {
    payForSprayMoneyV1(payload: $payload)
  }
`;

export const GetInvitationSelfiePresignedUrl = gql`
  mutation GenerateInvitationSelfiePreSignedUrl(
    $eventId: UUID!
    $invitationId: UUID!
    $mediaType: String!
  ) {
    generateInvitationSelfiePreSignedUrl(
      event_id: $eventId
      invitation_id: $invitationId
      mediaType: $mediaType
    ) {
      file_uri
      invitation_id
      upload_url
      event_id
      expiry_time
      expiry_time_in_seconds
    }
  }
`;

export const verifyInvitationSelfieUpload = gql`
  mutation VerifyInvitationSelfieUpload(
    $eventId: UUID!
    $invitationId: UUID!
    $fileUri: String!
  ) {
    verifyInvitationSelfieUpload(
      event_id: $eventId
      invitation_id: $invitationId
      fileUri: $fileUri
    )
  }
`;

export const SignUpByInviteLink = gql`
  mutation signupByInviteLink($eventId: Int!, $inviteToken: String!) {
    signupByInviteLink(eventId: $eventId, inviteToken: $inviteToken) {
      auth_response {
        access_expiry
        access_token
        refresh_expiry
        refresh_token
        user {
          first_name
          last_name
          id
          uuid
          phone_number
          verified
          email
        }
      }
      invitation {
        uuid
        first_name
        last_name
        qr_code
        admits
        rsvp_status
        seating {
          admit_index
          table_name
          table_alias
          event_table_id
          event_part_id
          seat_number
          event_table_seat_id
          event_part {
            address
            name
            time
          }
        }
      }
    }
  }
`;

export const GenerateAsoebiPaymentMetadata = gql`
  mutation generateAsoebiPaymentMetadata(
    $event_id: UUID!
    $input: AseobiPaymentMetadataRequest!
  ) {
    generateAsoebiPaymentMetadata(event_id: $event_id, input: $input) {
      inawo_product
      event_id
      user_id
      aseobi_id
      note
      contact_email
      contact_phone_number
      delivery_address
      delivery_city
      delivery_zip_code
      payment_reference
      payment_provider
      split_payments {
        name
        sub_account_id
        sub_account_code
        split_percentage
        couples_account
      }
      vendors
      hash
      currency
      transaction_charge
      delivery_fee
      vat
      late_fee
      total_amount
      timestamp
      attires {
        order_id
        attire_id
        aseobi_id
        price_per_size_unit
        fee_percentage
        mark_up_percentage
        size_unit
        size
        total_price_per_quantity
        quantity
        total_price
        vendor
        vendor_product_id
        vendor_order_id
      }
      custom_fields {
        display_name
        variable_name
        value
      }
      total_payment_intent_amount
    }
  }
`;

export const VerifyTransaction = gql`
  mutation verifyTransaction(
    $reference: String!
    $provider: paymentProcessor!
    $subAccountId: String
  ) {
    verifyTransaction(
      reference: $reference
      provider: $provider
      sub_account_id: $subAccountId
    ) {
      id
      reference
      payment_processor
      event_uuid
      event_id
      user_uuid
      full_name
      currency
      amount
      status
      stage
      kind
    }
  }
`;

export const GenerateGiftPaymentMetadata = gql`
  mutation generateGiftPaymentMetadata($input: GiftPaymentMetadataRequest!) {
    generateGiftPaymentMetadata(input: $input) {
      custom_fields {
        display_name
        value
        variable_name
      }
      contact_email
      contact_phone_number
      currency_iso
      event_id
      full_name
      gift_id
      hash
      inawo_product
      note
      payment_provider
      payment_reference
      split_percentage
      sub_account_code
      sub_account_id
      timestamp
      user_id
      wish_list_item_id
    }
  }
`;

export const incrementEventWebsiteView = gql`
  mutation IncrementEventWebsiteView($eventId: UUID!) {
    incrementEventWebsiteView(event_id: $eventId)
  }
`;

export const initiateStripePaymentIntent = gql`
  mutation InitiateStripePaymentIntent($args: initiatePaymentInput!) {
    initiateStripePaymentIntent(args: $args) {
      reference
      authorization_url
      client_secret
    }
  }
`;

export const RequestGuestLoginOTP = gql`
  mutation RequestGuestLoginOTP($eventId: UUID!, $email: String!) {
    requestGuestLoginOTP(event_id: $eventId, email: $email)
  }
`;

export const GuestLogin = gql`
  mutation GuestLogin($input: GuestLoginRequest!) {
    guestLogin(input: $input) {
      refresh_token
      refresh_expiry
      access_token
      access_expiry
      user {
        first_name
        last_name
        id
        uuid
        phone_number
        verified
        email
      }
    }
  }
`;

export const REQUEST_PLUS_ONE = gql`
  mutation RequestPlusOne($eventId: UUID!, $guest: PlusOneGuestInput!) {
    requestPlusOne(event_id: $eventId, guest: $guest) {
      id
      invitation_id
      status
      guest_email
      guest_first_name
      guest_last_name
      guest_phone
      created_at
    }
  }
`;
